var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('div',{staticClass:"body-profile"},[_c('IconsTile')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }